export const TYPE_STRING = 'STRING';
export const TYPE_DATE = 'DATE';
export const TYPE_MONEY = 'MONEY';
export const TYPE_NUMBER = 'NUMBER';
export const TYPE_TIMESTAMP = 'TIMESTAMP';

/**
 * Remove acentos de strings
 * @param  {String} string acentuada
 * @return {String} string sem acento
 */

var map = {
  â: 'a',
  Â: 'A',
  à: 'a',
  À: 'A',
  á: 'a',
  Á: 'A',
  ã: 'a',
  Ã: 'A',
  ê: 'e',
  Ê: 'E',
  è: 'e',
  È: 'E',
  é: 'e',
  É: 'E',
  î: 'i',
  Î: 'I',
  ì: 'i',
  Ì: 'I',
  í: 'i',
  Í: 'I',
  õ: 'o',
  Õ: 'O',
  ô: 'o',
  Ô: 'O',
  ò: 'o',
  Ò: 'O',
  ó: 'o',
  Ó: 'O',
  ü: 'u',
  Ü: 'U',
  û: 'u',
  Û: 'U',
  ú: 'u',
  Ú: 'U',
  ù: 'u',
  Ù: 'U',
  ç: 'c',
  Ç: 'C',
};

export function removerAcentos(s) {
  // eslint-disable-next-line no-useless-escape
  return s.replace(/[\W\[\] ]/g, function(a) {
    return map[a] || a;
  });
}

// export const dateToView = (val, verHora = false) => {
//   if (val === '' || val === null) return '';
//   let date;
//   if (val.length === 10) {
//     date = new Date(val + 'T10:00:00').toLocaleString('pt-BR', {});
//     verHora = false;
//   } else {
//     date = new Date(val).toLocaleString('pt-BR', {});
//   }
//   date = verHora === true ? date : date.substr(0, 10);

//   return date;
// };

export const dateToView = (val, verHora = false) => {
  if (val === '' || val === null) return '';
  let date = val
    .substr(0, 10)
    .split('-')
    .reverse()
    .join('/');
  if (val.length === 10) {
    date = date + ' 00:00:00';
    verHora = false;
  } else {
    date = date + ' ' + val.substr(11, 8);
  }
  date = verHora === true ? date : date.substr(0, 10);

  return date;
};

export const numberToMoney = num => {
  var n = typeof num != 'number' ? Number(num) : num;
  var money = new Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'BRL',
  })
    .format(n.toFixed(2))
    .substring(3, 15);
  return `R$ ${money}`;
};

export const leftPad = (value, numZeros = 3, letter = '0') => {
  var str = String(value);
  var addZeros = numZeros - str.length;
  var i = 0;
  while (i < addZeros) {
    str = letter + str;
    ++i;
  }
  return str;
};

export const numberToTel = num => {
  var tel = String(num);
  tel = tel.replace(/\D/g, ''); //limpa
  var q = tel.length;
  tel = tel.replace(/(\d)(\d{4})$/, '$1-$2'); //hifen
  if (q > 8) tel = tel.replace(/^(\d{2})(\d)/g, '($1) $2'); //parenteses
  return tel;
};

export const numberToCell = num => {
  var cell = String(num);
  cell = cell.replace(/\D/g, '');
  var q = cell.length;
  if (q === 8) {
    cell = '9' + cell;
    ++q;
  }
  cell = cell.replace(/(\d)(\d{4})$/, '$1-$2');
  if (q > 9) cell = cell.replace(/^(\d{2})(\d)/g, '($1) $2');
  return cell;
};
